export const checkIsHomePage = (
  pathname: string,
  isSimpleStorefront: boolean,
  isGiftCardOnly: boolean = false
): boolean => {
  if (isGiftCardOnly) {
    return ["/", "/giftcard"].includes(pathname);
  }

  if (isSimpleStorefront) {
    return ["/services/all", "/all", "/menu/all", "/categories/all"].includes(
      pathname
    );
  }

  return ["/"].includes(pathname);
};
export const determineBackAction = (
  pathname: string,
  isSimpleStorefront: boolean,
  isGiftCardOnly?: boolean
): "HIDE_WEB_VIEW" | "NAVIGATE_BACK" => {
  return checkIsHomePage(pathname, isSimpleStorefront, isGiftCardOnly)
    ? "HIDE_WEB_VIEW"
    : "NAVIGATE_BACK";
};
